export default __webpack_public_path__ + "static/continuousoperation-7413a006c60580f10e2c0d3423adf9d7.png";